'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _IyvListCart = require('./IyvListCart.css');

var _IyvListCart2 = _interopRequireDefault(_IyvListCart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListCart = (_dec = (0, _reactCssModules2.default)(_IyvListCart2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListCart, _Component);

  //
  function IyvListCart(props) {
    (0, _classCallCheck3.default)(this, IyvListCart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListCart.__proto__ || (0, _getPrototypeOf2.default)(IyvListCart)).call(this, props));

    _this.countEmptySlots = function (cart) {
      var emptyCount = 0;
      for (var i = 0; i < cart.length; i++) {
        if (cart[i].id === 'N' || !cart[i].id) {
          emptyCount += 1;
        }
      }
      return emptyCount;
    };

    _this.clickAnalyzeCompare = function () {
      // if we have empty slots and but not all empty slots
      var emptySlots = _this.countEmptySlots(_this.props.cart.results);
      if (emptySlots < 3) {
        // manually build a query string (should do this differently)
        var url = _config2.default.routes.compare + '?';
        _this.props.cart.results.forEach(function (slot, slotIdx) {
          if (slot.id !== 'N') {
            url += 's' + (slotIdx + 1).toString() + '=' + slot.id + '&';
          }
        });
        _this.context.router.push(url);
      }
    };

    return _this;
  }
  //

  //

  //


  (0, _createClass3.default)(IyvListCart, [{
    key: 'render',

    //
    value: function render() {
      var _this2 = this;

      if (this.props.cart && this.props.cart.results && this.props.cart.results.length) {
        var emptyCount = this.countEmptySlots(this.props.cart.results);
        return _react2.default.createElement(
          'div',
          { styleName: 'hidden-xs' },
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            /* if every slot is empty, hide it */
            emptyCount < this.props.cart.results.length ? _react2.default.createElement(
              'div',
              { styleName: 'cart-fixed' },
              _react2.default.createElement(
                'div',
                { styleName: 'cart-clear-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'cart-clear-label' },
                  'Selected funds'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    styleName: 'cart-clear-btn',
                    onClick: this.props.resetCart
                  },
                  'Clear list'
                )
              ),
              /* render a slot or an empty slot */
              this.props.cart.results.map(function (slot, slotIndex) {
                if (slot.id !== 'N' && slot.shareclassStub) {
                  var _slot$shareclassStub = slot.shareclassStub,
                      name = _slot$shareclassStub.name,
                      ticker = _slot$shareclassStub.ticker,
                      fund_id = _slot$shareclassStub.fund_id,
                      investment_vehicle_id = _slot$shareclassStub.investment_vehicle_id,
                      fund_legal_name = _slot$shareclassStub.fund_legal_name;

                  var sTicker = ticker || 'N';

                  var url = _config2.default.routes.fund + '/' + _format2.default.sanitize(fund_legal_name) + '/' + sTicker + '/' + _config2.default.profilePath + '/' + fund_id + '/' + investment_vehicle_id;

                  return _react2.default.createElement(
                    'div',
                    {
                      styleName: 'cart-slot',
                      key: 'cart-slot-' + slotIndex
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'cart-slot-filled' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'cart-slot-title-clear' },
                        _react2.default.createElement(
                          'div',
                          {
                            styleName: 'cart-slot-clear',
                            onClick: function onClick() {
                              _this2.props.clickCompareSelect(slot.shareclassStub);
                            }
                          },
                          _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-trash' })
                        ),
                        _react2.default.createElement(
                          'div',
                          { styleName: 'cart-slot-title' },
                          name
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'cart-slot-subtitle' },
                        ticker || '',
                        '\xA0',
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: url,
                            title: name + ' | ' + _config2.default.app.title,
                            xstrong: true
                          },
                          'Profile'
                        )
                      )
                    )
                  );
                } else {
                  return _react2.default.createElement('div', {
                    styleName: 'cart-slot',
                    key: 'cart-slot-' + slotIndex
                  });
                }
              }),
              _react2.default.createElement(
                'div',
                {
                  styleName: this.countEmptySlots(this.props.cart.results) > 2 ? 'cart-submit-disabled' : 'cart-submit',
                  onClick: this.clickAnalyzeCompare
                },
                'Compare',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ) : null
          )
        );
      }
      return null;
    }
  }]);
  return IyvListCart;
}(_react.Component), _class2.propTypes = {
  cart: _react.PropTypes.object,
  resetCart: _react.PropTypes.func,
  cartChange: _react.PropTypes.func,
  clickCompareSelect: _react.PropTypes.func
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = IyvListCart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListCart/IyvListCart.js
// module id = 1349
// module chunks = 0